"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationSubSection = exports.NavigationItem = exports.NavigationList = exports.NavigationSection = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Collapsible = __importStar(require("@radix-ui/react-collapsible"));
var react_icons_1 = require("@radix-ui/react-icons");
var react_1 = require("@stitches/react");
var react_2 = require("react");
var stitches_config_1 = require("../stitches.config");
var Text_1 = require("./Text");
var NavigationItemCss = (0, stitches_config_1.css)({
    paddingInline: "12px",
    paddingBlock: "6px",
    borderRadius: "6px",
    gap: "12px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
});
var TitleContainer = (0, react_1.styled)("div", {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "12px",
});
var NavigationListCss = (0, stitches_config_1.css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "4px",
    width: "100%",
});
var StyledNavigationSection = (0, react_1.styled)(Collapsible.Root, {
    width: "100%",
});
var StyledNavigationSectionHeader = (0, react_1.styled)("div", NavigationItemCss, {
    color: stitches_config_1.theme.colors.gray11,
    cursor: "pointer",
});
function NavigationSection(props) {
    var _a = (0, react_2.useState)(true), open = _a[0], setOpen = _a[1];
    return ((0, jsx_runtime_1.jsxs)(StyledNavigationSection, __assign({ open: open, onOpenChange: setOpen }, { children: [(0, jsx_runtime_1.jsx)(Collapsible.Trigger, __assign({ asChild: true }, { children: (0, jsx_runtime_1.jsxs)(StyledNavigationSectionHeader, { children: [open ? (0, jsx_runtime_1.jsx)(react_icons_1.TriangleDownIcon, {}) : (0, jsx_runtime_1.jsx)(react_icons_1.TriangleRightIcon, {}), (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ variant: "text-xs" }, { children: props.title }))] }) })), (0, jsx_runtime_1.jsx)(Collapsible.Content, __assign({ asChild: true }, { children: (0, jsx_runtime_1.jsx)(exports.NavigationList, { children: props.children }) }))] })));
}
exports.NavigationSection = NavigationSection;
exports.NavigationList = (0, react_1.styled)("div", NavigationListCss, {});
var StyledNavigationItem = (0, react_1.styled)("div", NavigationItemCss, {
    cursor: "pointer",
    "&:hover": {
        background: stitches_config_1.theme.colors.gray4,
    },
    variants: {
        active: {
            true: {
                background: stitches_config_1.theme.colors.gray4,
            },
        },
    },
});
var StyledIcon = (0, react_1.styled)("div", {
    color: stitches_config_1.theme.colors.gray11,
});
exports.NavigationItem = (0, react_2.forwardRef)(function (props, ref) {
    var name = props.name, icon = props.icon, active = props.active, otherProps = __rest(props, ["name", "icon", "active"]);
    return ((0, jsx_runtime_1.jsxs)(StyledNavigationItem, __assign({ active: active }, otherProps, { ref: ref }, { children: [icon && (0, jsx_runtime_1.jsx)(StyledIcon, { as: icon }), (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ variant: "text-sm" }, { children: props.name }))] })));
});
function NavigationSubSection(props) {
    return ((0, jsx_runtime_1.jsxs)(StyledNavigationSection, __assign({ open: props.isActive }, { children: [(0, jsx_runtime_1.jsx)(Collapsible.Trigger, __assign({ asChild: true }, { children: (0, jsx_runtime_1.jsxs)(StyledNavigationItem, __assign({ css: { flex: 1 } }, { children: [props.icon && (0, jsx_runtime_1.jsx)(StyledIcon, { as: props.icon }), (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ variant: "text-sm" }, { children: props.title }))] })) })), (0, jsx_runtime_1.jsx)(Collapsible.Content, __assign({ asChild: true }, { children: (0, jsx_runtime_1.jsx)(exports.NavigationList, { children: props.children }) }))] })));
}
exports.NavigationSubSection = NavigationSubSection;
//# sourceMappingURL=Navigation.js.map